import { render } from "./Reported.vue?vue&type=template&id=912ef5ac"
import script from "./Reported.vue?vue&type=script&lang=js"
export * from "./Reported.vue?vue&type=script&lang=js"

import "./Reported.vue?vue&type=style&index=0&id=912ef5ac&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__